import axios from "axios";
import { VEHICLE_KEY_BY_NAME } from "@/lib/bookingConfig";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function terminalFromFlightType(ft) {
  if (ft === "International") return "T1";
  if (ft === "Domestic") return "T2";
  return null;
}

// Build a /api/quote payload from a vehicle name + booking detail fields.
// Returns null when we don't yet have enough info (pickup + dropoff + vehicle).
export function buildQuotePayload({ vehicleName, details = {} }) {
  const vehicle_key = VEHICLE_KEY_BY_NAME[vehicleName];
  if (!vehicle_key) return null;

  const pickup =
    details.pickup_location ||
    details.pickup_address ||
    details.arrival_airport ||
    details.pickup ||
    "";
  const dropoff =
    details.destination ||
    details.dropoff_address ||
    details.destination_airport ||
    details.wedding_venue ||
    details.event_location ||
    details.cruise_terminal ||
    "";
  if (!pickup || !dropoff) return null;

  return {
    pickup,
    dropoff,
    vehicle_key,
    passengers: Number(details.passengers) || 1,
    luggage: Number(details.luggage_count) || 0,
    child_seats: Number(details.children_under_6) || 0,
    waiting_minutes: 0,
    terminal: terminalFromFlightType(details.flight_type),
  };
}

export async function fetchQuote(payload) {
  const res = await axios.post(`${API}/quote`, payload);
  return res.data;
}

export const money = (n) =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency: "AUD" }).format(
    Number(n || 0),
  );
